type GateListener = (open: boolean) => void;
type SessionListener = () => void;

let pending: Promise<void> | null = null;
let resolvePending: (() => void) | null = null;
let rejectPending: ((reason: Error) => void) | null = null;
const gateListeners = new Set<GateListener>();
const sessionListeners = new Set<SessionListener>();

function emitGate(open: boolean) {
  gateListeners.forEach((listener) => listener(open));
}

export function requireMfaStepUp(): Promise<void> {
  if (pending) return pending;
  pending = new Promise<void>((resolve, reject) => {
    resolvePending = resolve;
    rejectPending = reject;
  });
  emitGate(true);
  return pending;
}

export function completeMfaStepUp() {
  resolvePending?.();
  pending = null;
  resolvePending = null;
  rejectPending = null;
  emitGate(false);
}

export function cancelMfaStepUp(message = "Multi-factor verification was cancelled.") {
  rejectPending?.(new Error(message));
  pending = null;
  resolvePending = null;
  rejectPending = null;
  emitGate(false);
}

export function subscribeMfaStepUp(listener: GateListener): () => void {
  gateListeners.add(listener);
  listener(pending !== null);
  return () => gateListeners.delete(listener);
}

export function notifySessionExpired() {
  cancelMfaStepUp("Your session is no longer available.");
  sessionListeners.forEach((listener) => listener());
}

export function subscribeSessionExpired(listener: SessionListener): () => void {
  sessionListeners.add(listener);
  return () => sessionListeners.delete(listener);
}
